import React from 'react';


const GlobalPresence = () => {
  return (
    <div
      className="counter_area white bg_fixed pt-40 pb-40"
      style={{ backgroundImage: 'url(assets/images/cn-bg.jpg)', backgroundSize: 'cover', backgroundPosition: 'center' }}
    >
      <div className="container">
        <div className="row ">
          <p><b>Headquartered in India, with a global footprint spanning over 150+ countries across APAC, EMEA, and North America, we deliver tailored, data-driven solutions to organizations across diverse industries.</b></p>
          <p><b>By integrating our specialized  GTM | ABM data solutions, we elevate account-based marketing campaigns to new heights, ensuring impactful engagement with your target audience.</b>
          </p>
        </div>
      </div>
    </div>
  );
};

export default GlobalPresence;
